"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section-row-select"
  }, [_c("b-field", {
    staticClass: "section-field",
    attrs: {
      label: _vm.sectionLabel
    }
  }, [_c("b-select", {
    attrs: {
      placeholder: _vm.sectionPlaceholder,
      disabled: _vm.disabled || _vm.sectionRowDisabled,
      loading: _vm.isLoading,
      expanded: ""
    },
    model: {
      value: _vm.selectedSectionId,
      callback: function callback($$v) {
        _vm.selectedSectionId = $$v;
      },
      expression: "selectedSectionId"
    }
  }, [_c("option", {
    attrs: {
      disabled: ""
    },
    domProps: {
      value: null
    }
  }, [_vm._v("\n        " + _vm._s(_vm.sectionPlaceholder) + "\n      ")]), _vm._v(" "), _vm._l(_vm.sections, function (section) {
    return _c("option", {
      key: section.id,
      domProps: {
        value: section.id
      }
    }, [_vm._v("\n        " + _vm._s(section.name) + "\n      ")]);
  })], 2)], 1), _vm._v(" "), _c("b-field", {
    staticClass: "row-field",
    attrs: {
      label: _vm.rowLabel
    }
  }, [_c("b-select", {
    attrs: {
      placeholder: _vm.rowPlaceholder,
      disabled: !_vm.availableRows.length || _vm.disabled || _vm.sectionRowDisabled,
      loading: _vm.isLoading,
      expanded: ""
    },
    model: {
      value: _vm.selectedRowId,
      callback: function callback($$v) {
        _vm.selectedRowId = $$v;
      },
      expression: "selectedRowId"
    }
  }, [_c("option", {
    attrs: {
      disabled: ""
    },
    domProps: {
      value: null
    }
  }, [_vm._v("\n        " + _vm._s(_vm.rowPlaceholder) + "\n      ")]), _vm._v(" "), _vm._l(_vm.availableRows, function (row) {
    return _c("option", {
      key: row.id,
      attrs: {
        disabled: _vm.isRowDisabled(row.id)
      },
      domProps: {
        value: row.id
      }
    }, [_vm._v("\n        " + _vm._s(row.name) + "\n      ")]);
  })], 2)], 1), _vm._v(" "), _vm.showQuantity ? _c("b-field", {
    staticClass: "quantity-field",
    attrs: {
      label: _vm.quantityLabel
    }
  }, [_c("b-input", {
    attrs: {
      value: _vm.quantityInput,
      type: "number",
      placeholder: _vm.quantityPlaceholder,
      disabled: _vm.quantityDisabled || _vm.disabled,
      min: _vm.quantityMin,
      step: _vm.quantityStep
    },
    on: {
      input: _vm.handleQuantityInput
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;